/* eslint-disable no-restricted-syntax */
import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
// @mui
import { Container, Grid } from '@mui/material';
import { useLocation, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
// components
import BreadCrumb from '../../components/breadcrumb/BreadCrumbNavigation';
import Loading from '../../layouts/loading';
import { getEmployee } from '../../services/employeeService';
import { getAllProjects } from '../../services/projectService';
import { fetchMonthStats, fetchTimelineData } from '../../services/timelineService';
import { fetchRunningTask } from '../../services/trackerService';
import capitalizeWords from '../../utils/capitalize';
import { Calendar, TimeHistory, TimelineChart, TotalTime } from './components';
// ----------------------------------------------------------------------

export default function TimelinePage() {
  const [date, setDate] = useState(new Date());
  const [runningTask, setRunningTask] = useState();
  const [trackerList, setTrackerList] = useState([]);
  const [projectList, setProjectList] = useState([]);
  const [employeeList, setEmployeeList] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [totalTime, setTotalTime] = useState(0);
  const [month, setMonth] = useState();
  const [monthlyStat, setMonthlyStat] = useState([]);
  const { id } = useParams();

  const location = useLocation();
  const fetchTimeline = async () => {
    setLoading(true);
    try {
      const startTime = new Date(date?.setHours(0, 0, 0)).toISOString();
      const stopTime = new Date(date?.setHours(23, 59, 59)).toISOString();
      const response = await fetchTimelineData({ startTime, stopTime, userId: id });
      setTrackerList(response?.data?.data);
      let total = 0;
      for (const tracker of response?.data?.data) {
        total += new Date(tracker?.stopTime) - new Date(tracker?.startTime);
      }
      setTotalTime(total);
    } catch (error) {
      toast.error(error?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  const fetchDailyTotalInMonth = async () => {
    try {
      // Build month bounds using explicit day=1 to avoid overflow
      // (e.g. Mar 31 -> setMonth(Apr) can become May 1 in JS date math).
      const selectedDate = month ? new Date(month) : new Date(date);
      const currentYear = selectedDate.getFullYear();
      const currentMonth = selectedDate.getMonth();
      const startISO = new Date(currentYear, currentMonth, 1, 0, 0, 0, 0);
      const stopISO = new Date(currentYear, currentMonth + 1, 1, 0, 0, 0, 0);

      // setting timezone
      const offset = new Date().getTimezoneOffset();
      const offsetInFormat = offset / -60;
      const offsetInFormatHour = Math.floor(offsetInFormat);
      const offsetInFormatMinute = (offsetInFormat - offsetInFormatHour) * 60;
      const timezone = `${offsetInFormatHour >= 0 ? '+' : '-'}${offsetInFormatHour
        .toString()
        .padStart(2, '0')}:${offsetInFormatMinute.toString().padStart(2, '0')}`;

      const response = await fetchMonthStats({ startTime: startISO, stopTime: stopISO, timezone, userId: id });
      setMonthlyStat(response?.data?.data);
    } catch (error) {
      toast.error(error?.response?.data?.message);
    }
  };

  const fetchProjectData = async () => {
    const Projects = await getAllProjects({ status: 'active' });
    setProjectList(Projects?.data?.data?.rows);
  };
  const fetchEmployeData = async () => {
    const Employee = await getEmployee({
      pageSize: 100,
      status: 'active',
    });
    setEmployeeList(Employee?.data?.data?.rows);
  };
  // const fetchTaskeData = async () => {
  //   const Task = await getTasks();
  //   setTaskList(Task?.data?.data);
  // };

  const fetchRunningTaskData = async () => {
    const runningTaskResponse = await fetchRunningTask(id);
    setRunningTask(runningTaskResponse?.data?.data);
  };
  useEffect(() => {
    fetchProjectData();
    // fetchTaskeData();
    fetchEmployeData();
    fetchRunningTaskData();
  }, []);

  useEffect(() => {
    fetchDailyTotalInMonth();
    // eslint-disable-next-line
  }, [month]);

  useEffect(() => {
    fetchTimeline();
    // eslint-disable-next-line
  }, [date]);

  const breadcrumbs = [
    {
      label: 'Home',
      path: '/',
    },
    location?.state?.name
      ? {
          label: capitalizeWords(location.state.name),
          path: '', // Or set the appropriate path if needed
        }
      : null,
    {
      label: 'Timeline',
      path: '', // Or set the appropriate path if needed
    },
  ].filter(Boolean); // This removes any null values from the array
  return (
    <>
      <Helmet>
        <title>Timeline </title>
      </Helmet>

      <BreadCrumb breadcrumbs={breadcrumbs} />
      <Container>
        <Loading open={isLoading} />

        {/* <Header /> */}

        <Grid container spacing={2}>
          <Grid item xs={12} md={5} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <Calendar
              date={date}
              setDate={setDate}
              setMonth={setMonth}
              monthlyStat={monthlyStat}
              runningTask={runningTask}
            />
          </Grid>
          <Grid item xs={12} md={7}>
            <TotalTime
              employeeList={employeeList}
              projectList={projectList}
              date={date}
              totalTime={totalTime}
              runningTask={runningTask}
              fetchTimeline={fetchTimeline}
            />
          </Grid>
          <Grid item xs={12}>
            <TimelineChart trackerList={trackerList} runningTask={runningTask} date={date} />
          </Grid>
          <Grid item xs={12}>
            <TimeHistory
              trackerList={trackerList}
              projectList={projectList}
              employeeList={employeeList}
              fetchTimeline={fetchTimeline}
              runningTask={runningTask}
              date={date}
            />
          </Grid>
        </Grid>
      </Container>
    </>
  );
}
